<script setup lang="ts">
import { defineProps, ref } from "vue";

import Login from "@/components/auth/Login.vue";
import Recovery from "@/components/auth/Recovery.vue";
import SocialLogin from "@/components/auth/SocialLogin.vue";
import Btn from "@/components/ui/atoms/Btn.vue";
import PillContainer from "@/components/ui/atoms/PillContainer.vue";

const showRecovery = ref(false);

defineProps({
  visible: Boolean,
});
</script>

<template>
  <div :class="['side-box ', { 'side-box--visible': visible }]">
    <Transition :duration="{ enter: 240, leave: 240 }">
      <section class="side-box__section" v-if="visible">
        <PillContainer tag="div" on-right>
          <Btn
            tag="button"
            size="small"
            theme="dark-bold"
            shape="round"
            @click="$emit('closeSidebar')"
          >
            Cerrar
          </Btn>
        </PillContainer>
        <Recovery v-if="showRecovery" @recovery="showRecovery = false" />
        <Login v-else @recovery="showRecovery = true" />
        <SocialLogin />
      </section>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/settings/vars";

.side-box {
  position: fixed;
  width: 520px;
  right: -520px;
  box-sizing: border-box;
  background-color: vars.$iron;
  bottom: 0;
  top: 0;
  padding: 0 8px;
  z-index: 999;
  transition: right 0.4s ease-in-out;

  &__section {
    color: vars.$off-white;
    padding: 0.75rem;
  }

  &--visible {
    right: -0;
  }

  .button {
    margin-left: auto;
  }
}

@media (max-width: 1024px) {
  .side-box {
    right: -100%;
    width: 100%;

    &--visible {
      right: 0;
    }
  }
}
</style>
